/**
 * WelcomeStep Component
 * Step 4: 30-day free trial confirmation with auto-redirect to the app.
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckCircle2, Loader2 } from 'lucide-react';
import { IconContainer } from '@/components/ui';

export const WelcomeStep: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="text-center py-8">
      <IconContainer variant="success" size="xl" className="mx-auto mb-4">
        <CheckCircle2 className="w-8 h-8" />
      </IconContainer>
      <h2 className="text-xl font-bold text-slate-900 mb-2">
        {t('signup.welcomeTitle')}
      </h2>
      <p className="text-slate-600 mb-2">
        {t('signup.trialStarted')}
      </p>
      <p className="text-sm text-slate-500 mb-6">
        {t('signup.welcomeDescription')}
      </p>
      <div className="flex items-center justify-center gap-2 text-emerald-600">
        <Loader2 className="w-4 h-4 animate-spin" />
        <span className="text-sm">{t('signup.redirecting')}</span>
      </div>
    </div>
  );
};

export default WelcomeStep;
